import { render, staticRenderFns } from "./assessment-notes-input.vue?vue&type=template&id=88ae64a6&scoped=true&"
import script from "./assessment-notes-input.vue?vue&type=script&lang=js&"
export * from "./assessment-notes-input.vue?vue&type=script&lang=js&"
import style0 from "./assessment-notes-input.vue?vue&type=style&index=0&id=88ae64a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88ae64a6",
  null
  
)

export default component.exports